<template>
  <div class="flex-grow-1 w-100 d-flex align-items-center">
    <div class="bg-composed-wrapper--content">
      <div class="row no-gutters">
        <div class="col-sm-6 p-0 img-banner-left">
          <div class="flex-grow-1 w-100  align-items-center">
            <VueSlickCarousel
              :dots="true"
              :adaptiveHeight="true"
              :arrows="false"
              :autoplay="true"
            >
              <div class="wrap" :style="wrapStyle">
                <img
                  src="@/assets/img/image_Register1.png"
                  :style="wrapImgStyle"
                  alt="Banner register  1"
                />
              </div>
              <div class="wrap" :style="wrapStyle">
                <img
                  src="@/assets/img/izidok_loginpage_promo_2_rev3.jpg"
                  :style="wrapImgStyle"
                  alt="Banner izidok 3"
                />
              </div>
            </VueSlickCarousel>
          </div>
        </div>
        <div
          class="col-md-6 col-sm-6 d-flex align-items-center content-register-right"
        >
          <div
            class="col-sm-10 mt-2"
            style="margin-left:auto;margin-right:auto;font-size:14px;"
          >
            <h4 class="font-weight-bold" style="font-size:16px">
              Daftar izidok Sekarang!
            </h4>
            <p>
              Bergabunglah bersama lebih dari 350 dokter praktik mandiri
              pengguna izidok.
            </p>
            <b-form @submit.prevent="submitForm">
              <template v-if="formBasicData && formBasicData.length">
                <b-form-group
                  v-for="form in formBasicData"
                  :key="form.tmpId"
                  :class="
                    form.rawLabel == 'No. SIP' || form.name == 'info_izidok'
                      ? ''
                      : 'text-capitalize'
                  "
                  :invalid-feedback="
                    renderInvalidFeedback({
                      validationDesc: form['validation-desc']
                    })
                  "
                  :state="renderError({ error: form.error })"
                  style="margin-top:-10px;font-size:12px !important"
                >
                  <template
                    v-if="
                      form.isType === 'password' || form.isType == 'password'
                    "
                  >
                    <label for="">{{ form.rawLabel }}</label>
                    <label v-show="form.required" for="" style="color:red"> *</label>
                    <b-input-group style="height:34px">
                      <b-input-group-text
                        slot="append"
                        class="border-left-0"
                        v-if="form.name == 'password'"
                        @click="switchVisibilityPassword"
                      >
                        <font-awesome-icon
                          v-if="passwordVisible == false"
                          icon="eye"
                        />
                        <font-awesome-icon v-else icon="eye-slash" />
                      </b-input-group-text>
                      <b-input-group-text
                        style="height:34px"
                        slot="append"
                        class="border-left-0"
                        v-if="form.name == 'password_confirmation'"
                        @click="switchVisibilityPasswordConfirmation"
                      >
                        <font-awesome-icon
                          v-if="passwordVisible1 == false"
                          icon="eye"
                        />
                        <font-awesome-icon v-else icon="eye-slash" />
                      </b-input-group-text>

                      <b-form-input
                        :type="form.type || 'text'"
                        class="border-right-0"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        style="height:34px"
                        :state="renderError({ error: form.error })"
                        :maxlength="form.maxlength"
                        :placeholder="form.placeholder"
                      />
                    </b-input-group>
                  </template>
                  <template v-else-if="form.type === 'select'">
                    <label for="">{{ form.rawLabel }}</label>
                    <label for="" style="color:red"> *</label>
                    <vue-select placeholder="Pilih salah satu dibawah ini" :clearable="false" :options="options"
                        v-model="formData.info_izidok" @input="clickDropdown" class="vs-custom-register"/>
                  </template>
                  <template v-else :type="form.type || 'text'">
                    <label for="">{{ form.rawLabel }}</label>
                    <label v-show="form.required" for="" style="color:red"> *</label>
                    <b-form-input
                      style="height:34px"
                      @input="
                        setValue({
                          rawLabel: form.rawLabel,
                          label: form.label,
                          $event,
                          tmpId: form.tmpId
                        })
                      "
                      :state="renderError({ error: form.error })"
                      :placeholder="form.placeholder"
                      :maxlength="form.maxlength"
                    />
                  </template>
                </b-form-group>
              </template>
              <div class="form-group">
                Dengan menekan tombol <strong>Daftar</strong>,
                <span class="text-capitalize">Anda</span> setuju dengan semua
                <a :href="'https://izidok.id/privacy-note'">
                  <span class="text-capitalize"
                    ><strong>syarat {{ "&" }} ketentuan </strong></span
                  >
                </a>
                serta
                <a :href="'https://izidok.id/privacy-note'">
                  <span class="text-capitalize"
                    ><strong>kebijakan privasi</strong></span
                  >
                </a>
                yang berlaku
              </div>
              <button
                type="submit"
                class="btn btn-md btn-block text-capitalize"
                style="background-color :#3F7EA7; color:white; border-radius : 10px;"
              >
                daftar
              </button>
              <div class="text-center" style="margin-top:2px;">
                Anda Sudah Memiliki Akun ?
                <a href="https://beta.izidok.id/login"> Masuk disini</a>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faFileSignature,
  faComments,
  faEye,
  faEyeSlash,
  faEdit,
  faImage
} from "@fortawesome/free-solid-svg-icons";
import {
  required,
  alphaNum,
  minLength,
  maxLength,
  sameAs,
  email,
  numeric,
  helpers
} from "vuelidate/lib/validators";

library.add(
  faArrowLeft,
  faEye,
  faEyeSlash,
  faFileSignature,
  faImage,
  faComments,
  faEdit
);

import VueSlickCarousel from "vue-slick-carousel";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data: () => ({
    tipeFaskesData: ["klinik", "tempat praktik"],
    selectedTipeFaskes: null,
    options: [
      { value: "Event seminar online", label: "Event seminar online" },
      { value: "Event seminar offline", label: "Event seminar offline" },
      { value: "Email", label: "Email" },
      { value: "Pencarian Google", label: "Pencarian Google" },
      { value: "Rekan Sejawat", label: "Rekan Sejawat" },
      { value: "Instagram", label: "Instagram" },
      { value: "Facebook", label: "Facebook" },
      { value: "Twitter", label: "Twitter" },
      { value: "Linkedin", label: "Linkedin" },
      { value: "Telemarketing Izidok", label: "Telemarketing Izidok" },
      { value: "Lainnya", label: "Lainnya" }
    ],
    formBasicData: null,
    formData: null,
    validateEmail: false,
    validateUsername: false,
    isClicked: false,
    selected: null,
    dataSpesialisasi: null,
    passwordVisible: false,
    passwordVisible1: false,
    windowHeight: 0
  }),
  components: {
    VueSlickCarousel,
    "vue-select": () => import("vue-select"),
  },
  watch: {
    selectedTipeFaskes(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.formBasicData = this.setFormBasicData();
      }
    }
  },
  validations() {
    return {
      formData: {
        email: {
          required,
          email,
          maxLength: maxLength(50),
          verifyEmail(val) {
            const { required: re, email: em } = this.$v.formData.email;
            if (val === "" || !re || !em) return true;

            return new Promise((resolve, reject) => {
              axios
                .get(`${this.url_api}/email/verify?email=${val}`)
                .then(res => {
                  const {
                    data: { status, message }
                  } = res;

                  resolve(status);
                })
                .catch(err => {
                  if (err.response) {
                    const x = err.response.data;
                    if (x && x.email) {
                      resolve(false);
                    }
                  } else {
                    resolve(true);
                  }
                })
                .finally(() => {
                  const x = "email";
                  this.triggerValidation({
                    label: x,
                    $v: this.$v,
                    $vm: this,
                    rawLabel: x
                  });
                });
            });
          }
        },
        nama_dokter: {
          required,
          maxLength: maxLength(50)
        },
        nama_klinik: {
          required,
          maxLength: maxLength(50)
        },
        nama_pic: {
          required,
          maxLength: maxLength(50)
        },
        "no._handphone": {
          numeric,
          required,
          maxLength: maxLength(15),
          minLength: minLength(10),

          verifyPhone(val) {
            // if(val.length<10)
            //   return
            if (this.timeVerifyPhone) clearTimeout(this.timeVerifyPhone);

            return new Promise((resolve, reject) => {
              this.timeVerifyPhone = setTimeout(() => {
                const { required: re } = this.$v.formData["no._handphone"];
                if (val === "" || !re) resolve(true);
                axios
                  .get(`${this.url_api}/phone/verify?nomor_telp=${val}`)
                  .then(res => {
                    const {
                      data: { status, message }
                    } = res;
                    // console.log('data',res)
                    resolve(status);
                  })
                  .catch(err => {
                    if (err.response) {
                      const x = err.response.data;
                      if (x && x.nomor_telp) {
                        resolve(false);
                      }
                    } else {
                      resolve(true);
                    }
                  })
                  .finally(() => {
                    const x = "no._handphone";
                    this.triggerValidation({
                      label: x,
                      $v: this.$v,
                      $vm: this
                    });
                    resolve(true);
                  });
              }, 450);
            });
          }
        },
        password: {
          required,
          maxLength: maxLength(15),
          verifyPassword(val) {
            if (val.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/)) {
              return true;
            } else {
              return false;
            }
          }
        },
        konfirmasi_password: {
          required,
          sameAsPassword: sameAs("password"),
          minLength: minLength(6),
          maxLength: maxLength(15)
        },
        info_izidok: {
          required
        },
        kode_referral: {
          maxLength: maxLength(6),
          minLength: minLength(6),
          alphaNum
        }
      }
    };
  },
  created() {
    const tipeFaskesDataLength = this.tipeFaskesData.length;
    this.selectedTipeFaskes = this.tipeFaskesData[tipeFaskesDataLength - 1];
  },
  mounted() {
    this.setFormData();
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", e => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
  computed: {
    wrapStyle() {
      return {
        height: this.windowHeight + "px"
      };
    },
    wrapImgStyle() {
      return {
        "max-height": this.windowHeight + "px"
      };
    },
    optionsTipeFaskes() {
      const tmp = this.tipeFaskesData.slice(0);
      return tmp.reverse().map(item => ({
        text: item === "klinik" ? `${item} (akan segera hadir)` : item,
        value: item,
        disabled: item === "klinik"
      }));
    },
    emailValidation() {
      const x = {
        email,
        required,
        maxLength: maxLength(50)
      };

      const { required: re, email: em, maxLength: ml } = this.$v.formData.email;

      return re && em && ml
        ? {
            ...x,
            verifyEmail
          }
        : x;
    }
  },
  noTelpValidation() {
    const x = {
      email,
      required,
      maxLength: maxLength(15)
    };

    const { required: re, maxLength: ml } = this.$v.formData["no._handphone"];

    return re && ml
      ? {
          ...x,
          verifyPhone
        }
      : x;
  },
  methods: {
    switchVisibilityPassword() {
      this.formBasicData[3].type == "password"
        ? (this.formBasicData[3].type = "text")
        : (this.formBasicData[3].type = "password");
      if (this.formBasicData[3].type == "text") {
        this.passwordVisible = true;
      } else if (this.formBasicData[3].type == "password") {
        this.passwordVisible = false;
      }
    },
    switchVisibilityPasswordConfirmation() {
      this.formBasicData[4].type == "password"
        ? (this.formBasicData[4].type = "text")
        : (this.formBasicData[4].type = "password");
      if (this.formBasicData[4].type == "text") {
        this.passwordVisible1 = true;
      } else if (this.formBasicData[4].type == "password") {
        this.passwordVisible1 = false;
      }
    },
    clickDropdown(val) {
      if (val != "" || val != null) {
        this.formBasicData[5].error = false;
      }
    },
    whitelistValidation({ opts = "normalized" } = {}) {
      const tmp = ["no. izin klinik", "No. SIP"];

      return opts === "raw" ? tmp : tmp.map(item => item.split(" ").join("_"));
    },
    async addKlinik() {
      try {
        const { formData, formBasicData } = this;

        const tmpPostData = formBasicData.reduce((obj, item) => {
          const { label, name } = item;
          obj[name] = formData[label];
          return obj;
        }, {});

        const postData = {
          ...tmpPostData,
          tipe_faskes: 2,
          info_izidok : this.formData.info_izidok.value
        };

        const res = await axios.post(`${this.url_api}/klinik`, postData);
        const { status, data, message } = res.data;

        if (status) {
          this.$router.push({
            name: "verification-process",
            params: {
              email: postData.email,
              user_id: data.user_id,
              created_at: data.created_at,
              tipe_faskes: 2
            }
          });
        } else {
          // console.log(match);
          let match = message.match(/(email|nomor_telp) is already in used/);
          if (match) {
            this.$swal({
              title: `${startCase(match[1])} Tidak Dapat Digunakan`,
              text: `${startCase(match[1])} telah terdaftar. Silakan gunakan ${
                match[1]
              } lain untuk melakukan registrasi!`,
              type: "error"
            });
          }
        }
      } catch (err) {
        // console.log(err);
      }
    },
    submitForm() {
      const tmp = this.formBasicData.filter(
        item => !this.whitelistValidation().includes(item.label)
      );
      if (tmp.every(item => item.error !== null && !item.error)) {
        this.addKlinik();
      } else {
        tmp.map(item => {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this
          });
        });
      }
    },
    setFormData() {
      this.formData = this.setFormBasicData({
        noFilter: false
      }).reduce((arr, val) => {
        arr[val.label.split(" ").join("_")] = "";
        return arr;
      }, {});
    },
    setFormBasicData({ noFilter = true, showHidden = false } = {}) {
      const tmp = [
        {
          label: "nama dokter",
          placeholder: "Masukkan nama dokter",
          parent: "tempat praktik",
          name: "nama_klinik",
          rawLabel: "nama dokter",
          maxlength: 50,
          required: true,
        },
        {
          label: "no. handphone",
          placeholder: "Masukkan nomor handphone Anda",
          name: "nomor_telp",
          maxlength: 15,
          rawLabel: "no. handphone",
          required: true,
        },
        {
          label: "email",
          placeholder: "Masukkan email Anda",
          type: "email",
          name: "email",
          rawLabel: "email",
          maxlength: 50,
          required: true,
        },
        {
          label: "password",
          placeholder: "Masukkan password Anda",
          type: "password",
          isType: "password",
          name: "password",
          maxlength: 15,
          rawLabel: "password",
          required: true,
        },
        {
          label: "konfirmasi password",
          placeholder: "Masukkan password Anda sekali lagi",
          type: "password",
          rawLabel: "konfirmasi password",
          isType: "password",
          name: "password_confirmation",
          maxlength: 15,
          required: true,
        },
        {
          label: "info izidok",
          type: "select",
          rawLabel: "Dari mana Anda mengetahui tentang izidok?",
          isType: "select",
          name: "info_izidok",
          required: true,
        },
        {
          label: "kode_referral",
          type: "text",
          rawLabel: "Kode Referral",
          isType: "text",
          name: "kode_referral",
          maxLength: 6,
          minLength: 6,
          required: false,
          placeholder: "Masukkan kode referral",
        }
      ].map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        placeholder: item.placeholder,
        rawLabel: item.rawLabel
      }));

      return showHidden ? tmp : tmp.filter(item => !item.hide);
    },
    async getDataSpesialisasi() {
      try {
        const response = await axios.get("/spesialisasi");
      } catch (error) {
        // console.error(error);
      }
    },
    setValue({ label, rawLabel, $event = null } = {}) {
      const value = $event;

      this.formData[label] = value && value.trim();
      if (!this.whitelistValidation().includes(label)) {
        const confirms = ["password", "konfirmasi_password"];
        if (confirms.includes(label)) {
          confirms.forEach(item => {
            this.triggerValidation({
              label: item,
              $v: this.$v,
              $vm: this,
              rawLabel: item.split("_").join(" ")
            });
          });
        } else {
          this.triggerValidation({
            label,
            $v: this.$v,
            $vm: this,
            rawLabel
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.beforeClick {
  position: absolute;
  top: 72%;
  left: 6.3%;
  color: #d1d2db;
  font-size: 14px;
}

.beforeClickError {
  position: absolute;
  top: 74%;
  left: 6.3%;
  color: #d1d2db;
  font-size: 14px;
}
.afterClick {
  display: none;
}
</style>

<style lang="scss">

.v-select {
  &.vs-custom-register {
    & > .vs__dropdown-toggle {
      height: 37px !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
}

.vs-custom-register
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
  font-size: 16px !important;
  padding-left: 10px !important;
  font-family: "Poppins";
  font-weight: 400;
}

.dot-icon {
  width: 30px;
  height: 28px;
  background-color: white;
  border-radius: 50%;
}

.bg-composed-wrapper--bg,
.bg-composed-wrapper--image {
  opacity: 0.35;
}

.slick-dots li.slick-active button {
  width: 20px;
  background: #cac0c0;
}

.slick-dots {
  margin-bottom: 150px;
}

.img-banner-left {
  position: fixed;
}

.content-register-right {
  position: absolute;
  right: 0px;
  zoom: 90%;
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
}

.wrap img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  transform: translate(-50%, -50%);
}

@media only screen and (max-width: 600px) {
  .img-banner-left {
    position: relative;
    display: none;
  }

  .content-register-right {
    position: relative;
  }
}
</style>
